import { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import SEO from '../../components/SEO';

const PrivacyPage = () => {
    return (
        <Fragment>
            <SEO 
                title="Privacy Policy | Wilson Tamuka Attorneys | Data Protection Zimbabwe"
                description="Wilson Tamuka Attorneys' privacy policy outlines our commitment to protecting your personal information in accordance with Zimbabwe's data protection laws and POTRAZ regulations."
                keywords="privacy policy Zimbabwe, data protection Zimbabwe, POTRAZ compliance, legal privacy, attorney confidentiality Zimbabwe"
                canonical="https://wtafirm.co.zw/privacy"
            />
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'}/>
            <PageTitle pageTitle={'Privacy Policy'} pagesub={'Privacy Policy'} />
            <section className="wpo-terms-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="wpo-terms-wrap">
                                <div className="wpo-terms-text">
                                    <h2>Privacy Policy</h2>
                                    <p>Wilson Tamuka Attorneys (WTA) is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, store, and protect your data in accordance with Zimbabwe's data protection laws and international best practices.</p>
                                    
                                    <h3>1. Information We Collect</h3>
                                    <p>We collect personal information necessary to provide legal services, including:</p>
                                    <ul>
                                        <li>Personal identification details (name, ID number, contact information)</li>
                                        <li>Professional and business information</li>
                                        <li>Financial information relevant to your legal matter</li>
                                        <li>Communications between you and our firm</li>
                                        <li>Documents and records related to your case</li>
                                    </ul>

                                    <h3>2. How We Use Your Information</h3>
                                    <p>Your personal information is used exclusively for:</p>
                                    <ul>
                                        <li>Providing legal advice and representation</li>
                                        <li>Communicating with you about your legal matters</li>
                                        <li>Maintaining accurate records as required by the Law Society of Zimbabwe</li>
                                        <li>Complying with legal and regulatory obligations</li>
                                        <li>Processing payments and managing our client relationships</li>
                                    </ul>

                                    <h3>3. Data Protection and Security</h3>
                                    <p>We implement robust security measures to protect your information:</p>
                                    <ul>
                                        <li>Secure storage systems with restricted access</li>
                                        <li>Encrypted digital communications</li>
                                        <li>Regular security audits and updates</li>
                                        <li>Staff training on confidentiality and data protection</li>
                                        <li>Compliance with POTRAZ regulations and Zimbabwe Cyber and Data Protection Act</li>
                                    </ul>

                                    <h3>4. Sharing Your Information</h3>
                                    <p>We maintain strict confidentiality. Your information may only be shared:</p>
                                    <ul>
                                        <li>With your explicit consent</li>
                                        <li>When required by law or court order</li>
                                        <li>With third-party service providers bound by confidentiality agreements</li>
                                        <li>To protect our legal rights or prevent fraud</li>
                                    </ul>

                                    <h3>5. Your Rights</h3>
                                    <p>You have the right to:</p>
                                    <ul>
                                        <li>Access your personal information held by us</li>
                                        <li>Request corrections to inaccurate information</li>
                                        <li>Request deletion of your data (subject to legal retention requirements)</li>
                                        <li>Object to processing of your personal information</li>
                                        <li>Lodge a complaint with relevant authorities</li>
                                    </ul>

                                    <h3>6. Data Retention</h3>
                                    <p>We retain client information in accordance with Law Society of Zimbabwe requirements and applicable legislation. Legal files are typically retained for a minimum of seven years after the conclusion of a matter.</p>

                                    <h3>7. Website and Cookies</h3>
                                    <p>Our website may use cookies to enhance user experience. You can control cookie settings through your browser preferences.</p>

                                    <h3>8. Contact Us</h3>
                                    <p>For any privacy-related inquiries or to exercise your rights, please contact our Data Protection Officer at Wilson Tamuka Attorneys.</p>

                                    <p><strong>Last Updated:</strong> December 2025</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacyPage;
